import { render } from "./CalendarModal.vue?vue&type=template&id=2299a233"
import script from "./CalendarModal.vue?vue&type=script&lang=js"
export * from "./CalendarModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/vitamins/aaa/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__